module.exports = __webpack_public_path__ + "b25aef5aab093fd56dafea37d96bc9f3.MP3";